export default class NewsTabs {
    constructor() {
        this.fetchDomElements();
        this.openTabByUrlOnPageLoad();
    }

    fetchDomElements() {
        this.domElements = {
            newsTabs: document.querySelectorAll('.newsTabsContainer'),
            header: document.getElementById('header'),
        };
    }

    openTabByUrlOnPageLoad() {
        const hash = window.location.hash;
        if (hash && hash.startsWith('#tab')) {
            const tabName = hash.substring(1);
            this.openTabAndScrollToTabs(tabName);
        }
    }

    openTabAndScrollToTabs(tabName) {
        let tab = document.querySelectorAll('[role="tab"][href="#' + tabName + '"]')[0];
        let $tab = $(tab);

        // Show the requested tab
        $tab.tab('show');

        // Scroll to the tab
        let scrollTop = $tab.offset().top;
            
        scrollTop -= 15; // just some space between content element and header/breadcrumb
        scrollTop -= this.domElements.header.offsetHeight;

        $('html, body').animate({ scrollTop: scrollTop });
    }
}
